module.exports = {
  siteUrl: 'https://www.wenrbeveiliging.nl',
  title: 'W&R Beveiliging',
  trackingId: 'UA-134718623-1',
  defaultLanguage : 'nl',
}
